'use client';

import { useEffect, useState } from 'react';
import { MarketoFormShimmer } from './marketo-form-shimmer';

type MarketoFormElementProps = {
  formId: number;
};

export const MarketoFormElement = ({ formId }: MarketoFormElementProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasTimedOut, setHasTimedOut] = useState(false);

  useEffect(() => {
    const formElement = document.getElementById(`mktoForm_${formId}`);

    if (!formElement) return;

    // Simple check if form has content
    const checkIfLoaded = () => {
      const hasContent = formElement.children.length > 0;
      setTimeout(() => {
        setIsLoaded(hasContent);
      }, 100);
    };

    // Initial check
    checkIfLoaded();

    // Watch for content changes
    const observer = new MutationObserver(() => {
      checkIfLoaded();
    });

    observer.observe(formElement, {
      childList: true,
    });

    const timeoutId = window.setTimeout(() => {
      setHasTimedOut(true);
    }, 8000);

    return () => {
      observer.disconnect();
      window.clearTimeout(timeoutId);
    };
  }, [formId]);

  return (
    <>
      {!isLoaded && <MarketoFormShimmer />}
      {!isLoaded && hasTimedOut && (
        <div className="mt-4 text-sm">
          <p>Form is taking longer than expected to load.</p>
          <button
            type="button"
            className="underline"
            onClick={() => {
              if (typeof window !== 'undefined') {
                setHasTimedOut(false);
                window.dispatchEvent(new Event('mkto-forms2-retry'));
              }
            }}
          >
            Retry loading the form
          </button>
        </div>
      )}
      <div className={isLoaded ? 'block' : 'hidden'}>
        <form id={`mktoForm_${formId}`} />
      </div>
    </>
  );
};
